var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartnerWithUsHeaderBgT = function SvgPartnerWithUsHeaderBgT(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 305,
    height: 283,
    viewBox: "0 0 305 283",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "86.841%",
    x2: "13.918%",
    y1: "55.066%",
    y2: "28.314%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M51.766 204.114c41.8 196.722 158.861 60.134 207.664 188.962 40.277 106.32 192.452 82.094 236.23-30.81 22.67-58.465 21.036-184.177-108.196-254.411C264.189 40.857 9.966 7.393 51.766 204.115z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "97.919%",
    x2: "15.725%",
    y1: "-8.471%",
    y2: "60.663%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "64.727%",
    x2: "64.727%",
    y1: "67.925%",
    y2: "135.857%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-21 -286.931 728.14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    transform: "rotate(16 276.954 258.404)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.065,
    cy: 307.061,
    fill: "url(#c)",
    mask: "url(#d)",
    rx: 144.433,
    ry: 151.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.066,
    cy: 299.251,
    fill: "url(#e)",
    mask: "url(#d)",
    rx: 109.432,
    ry: 135.349,
    transform: "rotate(99 554.066 299.251)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartnerWithUsHeaderBgT);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/partner-with-us-header-bg-t.ae6ac2d9989cb6af15878f3ab907173e.svg";